// import Swiper from 'swiper/swiper'
// require('swiper/swiper.scss')
require('../../../src/lp/ashinagasan-ad1/style.scss')

window.onload = function () {
  // CTAボタンの表示切替処理
  const toggleCta = (items) => {
    items.forEach(item => {
      if (item.isIntersecting) {
        // 画面上にそのオブジェクトがある場合、CTAボタンを非表示にする
        cta.classList.remove('is-show');
        cta.classList.add('is-hide');
      } else {
        cta.classList.remove('is-hide');
        cta.classList.add('is-show');
      }
    })
  };

  // CTAボタンを非表示にするオブジェクト群 処理しやすいよう配列で取得
  const hideCtaItems = Array.from(document.querySelectorAll('.hide-cta:not(:first-child)'));
  // 先頭の要素はファーストビューにあるので最後に処理する
  hideCtaItems.push(document.querySelector('.hide-cta:first-child'));
  // CTAボタン
  const cta = document.querySelector('#js-float-cta');

  // CTAボタンの表示切替を監視するオブジェクトを作成
  const option = {
    root: null,
    threshold: 0
  };
  const observer = new IntersectionObserver(toggleCta, option);
  hideCtaItems.forEach(item => observer.observe(item));

  const titles = document.querySelectorAll('.p-lp-faq__question');
  titles.forEach((title) => {
    title.addEventListener('click', () => {

      const content = title.nextElementSibling;

      const isHidden = window.getComputedStyle(content).display === 'none';
      if (isHidden) {
        content.style.display = 'flex';
        title.classList.add('open');
      } else {
        content.style.display = 'none';
        title.classList.remove('open');
      }
    });
  });

  // swiper設定
  new Swiper('.swiper', {
    centeredSlides: true,
    loop: true,
    watchSlidesProgress: true,
    watchSlidesVisibility: true,
    speed: 300,
    autoplay: {
      enabled: false,
    },
    slidesPerView: 1.2,
    // autoHeight: true,
    spaceBetween: 12,
    breakpoints: {
      500: {
        speed: 300,
        slidesPerView: 2.5,
        autoplay: {
          enabled: false,
        },
      },
      1000: {
        speed: 3000,
        slidesPerView: 4.5,
        autoplay: {
          enabled: true,
          delay: 4000,
          disableOnInteraction: false,
        },
      }
    },

    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    on: {
      transitionStart: function () {
        document.querySelectorAll('.swiper-slide').forEach(function (elem) {
          elem.classList.remove('visible');
        });
        document.querySelector('.swiper-slide-active').classList.add('visible');
      },
    },
  });
}
